import React, { useState } from "react";
import DialogComponent from "../components/DialogComponent";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import axios from "axios";

function Invite({ setDailog, inviteData, sip, setList }) {
  const [InviteNumber, setInviteNumber] = useState(inviteData?.roomId || "");
  const [phoneNo, setPhoneNo] = useState("");
  const [, setData] = useState("No Data");
  const updatedUrl = localStorage.getItem("apiEndpoint");
  const baseURL = updatedUrl?.length ? updatedUrl : window.config.apiEndpoint;

  const handleInviteChange = (e) => {
    setInviteNumber(e.target.value);
  };

  const handlePhoneNoChange = (e) => {
    setPhoneNo(e.target.value);
  };

  function ClearResponse() {
    setData("");
  }

  function InviteAPI(event) {
    ClearResponse();
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    const roomId = InviteNumber;
    const requestBody = {
      Participant: phoneNo,
    };
    axios
      .post(`${baseURL}/accounts/${acId}/room/${roomId}/join`, requestBody, {
        headers: headers,
      })
      .then(function (response) {
        console.log(response);
        toast.success("Api call success");
        setList(false);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
    setDailog(false);
  }

  return (
    <>
      <DialogComponent
        heading="Invite"
        ButtonName="Invite"
        handleClick={InviteAPI}
        handleChange={handleInviteChange}
        handleChange1={handlePhoneNoChange}
        PlaceholderName2="Phone Number/SIP Uri*"
        data={InviteNumber}
        data1={phoneNo}
        PlaceholderName="Room ID*"
        setDailog={setDailog}
        sip={sip}
        inviteData={inviteData}
        setList={setList}
      />
    </>
  );
}
Invite.propTypes = {
  setDailog: PropTypes.any,
  inviteData: PropTypes.any,
  sip: PropTypes.any,
  setList: PropTypes.any,
};
export default Invite;
